export default {

    error(error, defaultMessage = 'An error occurred.') {
        if (!error?.response?.data) {
            return defaultMessage;
        }
        const data = error.response.data;
        if (data.message) {
            return data.message;
        }
        return defaultMessage;
    },

    async errorFromResponse(error, defaultMessage = 'An error occurred.') {
        if (!error?.response?.data) {
            return defaultMessage;
        }
        const data = error.response.data;
        if (data.message) {
            return data.message;
        }
        if (data instanceof Blob) {
            try {
                const text = await data.text();
                const json = JSON.parse(text);
                return json.message || defaultMessage;
            } catch (e) {
                return defaultMessage;
            }
        }
        return defaultMessage;
    }

}